import i18n from "@/libs/i18n";
import Vue from "vue";
import store from "@/store";

/* eslint-disable import/prefer-default-export */
/**
 * Returns the collective's URL.
 * @param {*} collective The collective
 * @returns The URL.
 */
export function getCollectiveUrl(collective, params = "") {
  if(!collective){
    return null;
  }

  // NEXOS
  if(process.env.VUE_APP_CUSTOMER === 'nexos'){
    return `https://nexos.bancolombia.com/${collective.slug}${params}`;
  }

  // INTERCONTINENTAL ALLIANCE
  const INTERCONTINENTAL_ALLIANCE_KEY = "6725a490-2547-11ee-a8ab-dfc8db3ddec2";
  const mainSpaceIsIntercontinental = collective.mainCommunityID === 68379 || collective.key === INTERCONTINENTAL_ALLIANCE_KEY || collective.communityMain === INTERCONTINENTAL_ALLIANCE_KEY;
  
  // Special case for intercontinental-alliance community
  if (mainSpaceIsIntercontinental) {
    console.log('mainSpaceIsIntercontinental');
    //check if the current domain is nectios.com or intercontinentalalliance.com
    const currentDomain = window.location.hostname;
    console.log('currentDomain', currentDomain);
    let domain = "nectios.com";
    if (currentDomain.includes("intercontinentalalliance.com")) {
      domain = "intercontinentalalliance.com";
    }
    console.log('domain', domain);
    return `https://app.${domain}/${collective.slug}${params}`;
  }

  return (
    process.env.VUE_APP_COMMUNITY_TEMPLATE_URL.replace(
      "{subdomain}",
      collective.subdomain || "app",
    ).replace("{slug}", collective.slug) + params
  );
}

export function selectLangFromCommunity(community) {
  const isNexos = process.env.VUE_APP_CUSTOMER === 'nexos';
  const defaultLang = isNexos ? "es" : "en";
  const lang = Vue.$cookies.get("i18n_redirected") || i18n.locale || defaultLang; 
  // console.log('selectLangFromCommunity', lang);

  const communityIncludesLang = community?.availableLanguages?.includes(lang);
  // console.log('communityIncludesLang', communityIncludesLang);

  const i18nRedirected = Vue.$cookies.get("i18n_redirected");
  // console.log('i18nRedirected', i18nRedirected);

  if (community && !communityIncludesLang) {
    // console.log('selectLangFromCommunity - lang not in available languages, switching to community language');
    const langCodeInAvailableLanguages = community.availableLanguages?.includes(community.languageCode);
    // console.log('langCodeInAvailableLanguages', langCodeInAvailableLanguages);

    const newLocale = langCodeInAvailableLanguages ? community.languageCode : community.availableLanguages?.[0];
    // console.log('newLocale', newLocale);

    // Set the new locale
    store.dispatch("setLocale", newLocale);

    // Update the i18n locale
    i18n.locale = newLocale;
    Vue.$cookies.set("i18n_redirected", i18n.locale);

    return newLocale;
  } else {
    // If the lang is in the available languages, keep it
    // console.log('selectLangFromCommunity - lang is in available languages');
    store.dispatch("setLocale", lang);

    return i18n.locale || defaultLang;
  }
}
